/*******************************************************************************
 * Copyright (c) 2021 Share Registry
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   Andrew Uskov - Extensive Improvements
 *   Amina Rais - Massive Improvements
 *
 * Version: 0.75
 *
 *******************************************************************************/

import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';

import './App.css'

import Pages from './pages'

const App = () => {

  useEffect(() => {
    AOS.init();

  }, [])



  return (
    <div className="main">

      <Pages />

    </div>
  )
}



export default App